@if (overlayService.visible()) {
<div class="tr-overlay" [class.tr-overlay-leaving]="overlayService.isLeaving()">
  
  <!-- Aura de Resplandor Neón Ambiental -->
  <div class="tr-ambient-glow"></div>

  <!-- Tarjeta de Cristal Ejecutivo (Glassmorphism UI/UX de Alto Nivel) -->
  <div class="tr-card">

    <!-- Logo Oficial FAISEN con resplandor neón pulsante -->
    <div class="tr-logo">
      <img src="images/logo-faisen/logo-faisen.png" alt="FAISEN" class="tr-logo-img" />
    </div>

    <!-- Barra de Progreso Shimmer Elegante -->
    <div class="tr-bar">
      <div class="tr-bar-fill"></div>
    </div>

    <!-- Mensaje de Estado -->
    <p class="tr-message">{{ overlayService.message() }}</p>

  </div>
</div>
}
